import { render, staticRenderFns } from "./RichEditorMenuBar.vue?vue&type=template&id=06b7fb89&scoped=true"
import script from "./RichEditorMenuBar.vue?vue&type=script&lang=js"
export * from "./RichEditorMenuBar.vue?vue&type=script&lang=js"
import style0 from "./RichEditorMenuBar.vue?vue&type=style&index=0&id=06b7fb89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7fb89",
  null
  
)

export default component.exports